export default access => access === 'F' || access === 'B'



// WEBPACK FOOTER //
// ./src/utils/hasBillesAccess.js